import { endpoints } from "../../../config";
import appClient, { ResultApi } from "../../common/services/AppClient";

export default class DocumentViewService {
    async getDocument(path: string): Promise<ResultApi<Blob | undefined>> {
        const url = `${endpoints.tasksUrl}document/${path}`;
        return appClient.get<Blob | undefined>(url, "blob");
    }
}
